import { HStack, StackProps } from '@chakra-ui/react';
import { PaginationLimit } from './pagination-limit';
import { PaginationPages } from './pagination-pages';

export function BasePagination(props: StackProps) {
  return <HStack spacing='md' align='center' justify='center' {...props} />;
}

BasePagination.Pages = PaginationPages;
BasePagination.Limit = PaginationLimit;

export * from './utils';
